import React, { useState } from 'react';
import defaultPicture from './images/default.png';

const DirectoryStacked = (props) => {

const [isHovered, setIsHovered] = useState(false);

const barStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    padding: '15px 20px',
    marginBottom: '10px',
    
    backgroundColor: '#D5B3E7',
    border: isHovered ? '1px solid #6E4884' : '1px solid #d3b4ec',
    borderRadius: '15px',
    boxShadow: isHovered ? '0px 4px 12px rgba(110, 72, 132, 0.4)' : '0px 2px 8px rgba(0, 0, 0, 0.2)',
    
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
};

const pictureStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid #6E4884',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
    flexShrink: 0,
};

const textContainerStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
};

const nameStyle = {
    margin: 0,
    fontSize: '1.2em',
    fontWeight: 'bold',
    color: 'black',
    fontFamily: 'Poppins',
};

const infoStyle = {
    margin: 0,
    fontSize: '0.95em',
    color: '#333',
    fontFamily: 'Poppins',
};

const isDefaultPhoto = props.photo && props.photo.startsWith("https://lh3.googleusercontent.com/");

const handleClick = () => {
    props.openPanel({
    displayName: props.displayName,
    classYear: props.classYear,
    concentration: props.concentration,
    photo: isDefaultPhoto ? defaultPicture : props.photo,
    email: props.email,
    linkedin: props.linkedin,
    instagram: props.instagram,
    role: props.role,
    bio: props.bio,
    companies: props.companies,
    interests: props.interests,
    courses: props.courses,
    coursesTaught: props.coursesTaught,
    });
};

return (
    <div 
    style={barStyle} 
    onClick={handleClick} 
    onMouseEnter={() => setIsHovered(true)} 
    onMouseLeave={() => setIsHovered(false)}
    >
    <img 
        src={isDefaultPhoto ? defaultPicture : props.photo} 
        alt="Profile" 
        style={pictureStyle} 
    />
    <div style={textContainerStyle}>
        <h3 style={nameStyle}>{props.displayName}</h3>
        <p style={infoStyle}>
        {props.role && `${props.role}`}
        {props.classYear && ` • Class of ${props.classYear}`}
        {props.concentration && ` • ${Array.isArray(props.concentration) ? props.concentration.join(', ') : props.concentration}`}
        </p>
    </div>
    </div>
);
};

export default DirectoryStacked;